import { TccCompositionRegionInfo } from "../types/data.interface";

export const formatTccCompositionRegionInfoIntoOption = (item: TccCompositionRegionInfo) => ({
  value: item,
  label: `${item.region.name} ${item.is_restrictive ? '(Restrictive)' : ''}`,
});

export const getSelectableTccCompositionRegions = (tccCompositionRegionInfo: TccCompositionRegionInfo[]) => tccCompositionRegionInfo.map(formatTccCompositionRegionInfoIntoOption);
